const data = {
    2014: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.43,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.1,
          color: "white"
        },
        {
          name: "kazakhstan",
          lat: 48.019573,
          lng: 66.923684,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.43
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "kazakhstan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.019573,
          endLng: 66.923684,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2015: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.1,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.1,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.2,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.1,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.1,
          color: "white"
        },
        {
          name: "kazakhstan",
          lat: 48.019573,
          lng: 66.923684,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.2
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "kazakhstan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.019573,
          endLng: 66.923684,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2016: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.48,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.1,
          color: "white"
        },
        {
          name: "bulgaria",
          lat: 42.733883,
          lng: 25.48583,
          size: 0.1,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.1,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.1,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.48,
          color: "white"
        },
        {
          name: "portugal",
          lat: 39.399871999999995,
          lng: -8.224454,
          size: 0.1,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.48
        },
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "bulgaria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 42.733883,
          endLng: 25.48583,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.48
        },
        {
          name: "portugal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.399871999999995,
          endLng: -8.224454,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2017: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.46,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "singapore",
          lat: 1.352083,
          lng: 103.819836,
          size: 0.1,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.31,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.1,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.24,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "brazil",
          lat: -14.235004,
          lng: -51.92528,
          size: 0.1,
          color: "white"
        },
        {
          name: "czech republic",
          lat: 49.817492,
          lng: 15.472961999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.17,
          color: "white"
        },
        {
          name: "australia",
          lat: -25.274398,
          lng: 133.775136,
          size: 0.1,
          color: "white"
        },
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.1,
          color: "white"
        },
        {
          name: "vietnam",
          lat: 14.058323999999999,
          lng: 108.277199,
          size: 0.1,
          color: "white"
        },
        {
          name: "nigeria",
          lat: 9.081999,
          lng: 8.675277000000001,
          size: 0.1,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.1,
          color: "white"
        },
        {
          name: "sudan",
          lat: 12.862807,
          lng: 30.217636,
          size: 0.1,
          color: "white"
        },
        {
          name: "slovenia",
          lat: 46.151241,
          lng: 14.995463,
          size: 0.1,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.1,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.46
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "singapore",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 1.352083,
          endLng: 103.819836,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.31
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "brazil",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -14.235004,
          endLng: -51.92528,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "czech republic",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 49.817492,
          endLng: 15.472961999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "australia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -25.274398,
          endLng: 133.775136,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "vietnam",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 14.058323999999999,
          endLng: 108.277199,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "nigeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.081999,
          endLng: 8.675277000000001,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "sudan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 12.862807,
          endLng: 30.217636,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "slovenia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.151241,
          endLng: 14.995463,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2018: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.1,
          color: "white"
        },
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.29,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.2,
          color: "white"
        },
        {
          name: "latvia",
          lat: 56.879635,
          lng: 24.603189,
          size: 0.13,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.16,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.1,
          color: "white"
        },
        {
          name: "mexico",
          lat: 23.634501,
          lng: -102.552784,
          size: 0.13,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.1,
          color: "white"
        },
        {
          name: "singapore",
          lat: 1.352083,
          lng: 103.819836,
          size: 0.1,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.13,
          color: "white"
        },
        {
          name: "czech republic",
          lat: 49.817492,
          lng: 15.472961999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.2,
          color: "white"
        },
        {
          name: "vietnam",
          lat: 14.058323999999999,
          lng: 108.277199,
          size: 0.1,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.1,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.1,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.1,
          color: "white"
        },
        {
          name: "bulgaria",
          lat: 42.733883,
          lng: 25.48583,
          size: 0.1,
          color: "white"
        },
        {
          name: "qatar",
          lat: 25.354826,
          lng: 51.183884,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.29
        },
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.2
        },
        {
          name: "latvia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.879635,
          endLng: 24.603189,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "mexico",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.634501,
          endLng: -102.552784,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "india",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 20.593684,
          endLng: 78.96288,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "singapore",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 1.352083,
          endLng: 103.819836,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "czech republic",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 49.817492,
          endLng: 15.472961999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.2
        },
        {
          name: "vietnam",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 14.058323999999999,
          endLng: 108.277199,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "bulgaria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 42.733883,
          endLng: 25.48583,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "qatar",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 25.354826,
          endLng: 51.183884,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2019: {
      loc: [
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.13,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.17,
          color: "white"
        },
        {
          name: "malaysia",
          lat: 4.210483999999999,
          lng: 101.97576600000001,
          size: 0.1,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.33,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.19,
          color: "white"
        },
        {
          name: "ethiopia",
          lat: 9.145,
          lng: 40.489672999999996,
          size: 0.17,
          color: "white"
        },
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.35,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.55,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.24,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "israel",
          lat: 31.046051000000002,
          lng: 34.851612,
          size: 0.12,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.24,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.21,
          color: "white"
        },
        { name: "croatia", lat: 45.1, lng: 15.2, size: 0.12, color: "white" },
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.1,
          color: "white"
        },
        {
          name: "brazil",
          lat: -14.235004,
          lng: -51.92528,
          size: 0.12,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.1,
          color: "white"
        },
        {
          name: "australia",
          lat: -25.274398,
          lng: 133.775136,
          size: 0.1,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.12,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.12,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.1,
          color: "white"
        },
        {
          name: "portugal",
          lat: 39.399871999999995,
          lng: -8.224454,
          size: 0.15,
          color: "white"
        },
        {
          name: "oman",
          lat: 21.512583,
          lng: 55.923255000000005,
          size: 0.1,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.15,
          color: "white"
        },
        {
          name: "kuwait",
          lat: 29.311659999999996,
          lng: 47.481766,
          size: 0.17,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.15,
          color: "white"
        },
        {
          name: "ghana",
          lat: 7.946527000000001,
          lng: -1.0231940000000002,
          size: 0.1,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.1,
          color: "white"
        },
        {
          name: "latvia",
          lat: 56.879635,
          lng: 24.603189,
          size: 0.1,
          color: "white"
        },
        {
          name: "romania",
          lat: 45.943160999999996,
          lng: 24.96676,
          size: 0.1,
          color: "white"
        },
        {
          name: "finland",
          lat: 61.92411,
          lng: 25.748151,
          size: 0.1,
          color: "white"
        },
        {
          name: "monaco",
          lat: 43.750298,
          lng: 7.412841,
          size: 0.12,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "malaysia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.210483999999999,
          endLng: 101.97576600000001,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.33
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.19
        },
        {
          name: "ethiopia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.145,
          endLng: 40.489672999999996,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.35
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.55
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "israel",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 31.046051000000002,
          endLng: 34.851612,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.21
        },
        {
          name: "croatia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.1,
          endLng: 15.2,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "india",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 20.593684,
          endLng: 78.96288,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "brazil",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -14.235004,
          endLng: -51.92528,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "australia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -25.274398,
          endLng: 133.775136,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "portugal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.399871999999995,
          endLng: -8.224454,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "oman",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 21.512583,
          endLng: 55.923255000000005,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "kuwait",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 29.311659999999996,
          endLng: 47.481766,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "ghana",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 7.946527000000001,
          endLng: -1.0231940000000002,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "latvia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.879635,
          endLng: 24.603189,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "romania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.943160999999996,
          endLng: 24.96676,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "finland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.92411,
          endLng: 25.748151,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "monaco",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 43.750298,
          endLng: 7.412841,
          color: ["blue", "red"],
          stroke: 0.12
        }
      ]
    },
    2020: {
      loc: [
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.45,
          color: "white"
        },
        {
          name: "malaysia",
          lat: 4.210483999999999,
          lng: 101.97576600000001,
          size: 0.15,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.35,
          color: "white"
        },
        {
          name: "mexico",
          lat: 23.634501,
          lng: -102.552784,
          size: 0.18,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.22,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.14,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.35,
          color: "white"
        },
        {
          name: "brazil",
          lat: -14.235004,
          lng: -51.92528,
          size: 0.18,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.22,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.24,
          color: "white"
        },
        {
          name: "new zealand",
          lat: -40.900557,
          lng: 174.88597099999998,
          size: 0.13,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.2,
          color: "white"
        },
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "ethiopia",
          lat: 9.145,
          lng: 40.489672999999996,
          size: 0.13,
          color: "white"
        },
        {
          name: "yemen",
          lat: 15.552726999999999,
          lng: 48.516388,
          size: 0.1,
          color: "white"
        },
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.18,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.12,
          color: "white"
        },
        {
          name: "colombia",
          lat: 4.570868,
          lng: -74.297333,
          size: 0.17,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.14,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.18,
          color: "white"
        },
        {
          name: "australia",
          lat: -25.274398,
          lng: 133.775136,
          size: 0.16,
          color: "white"
        },
        {
          name: "latvia",
          lat: 56.879635,
          lng: 24.603189,
          size: 0.1,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.18,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.27,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.12,
          color: "white"
        },
        {
          name: "portugal",
          lat: 39.399871999999995,
          lng: -8.224454,
          size: 0.11,
          color: "white"
        },
        {
          name: "iran",
          lat: 32.427908,
          lng: 53.68804599999999,
          size: 0.13,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.12,
          color: "white"
        },
        {
          name: "kuwait",
          lat: 29.311659999999996,
          lng: 47.481766,
          size: 0.14,
          color: "white"
        },
        {
          name: "indonesia",
          lat: -0.789275,
          lng: 113.921327,
          size: 0.11,
          color: "white"
        },
        {
          name: "turkey",
          lat: 38.963745,
          lng: 35.243322,
          size: 0.11,
          color: "white"
        },
        {
          name: "ukraine",
          lat: 48.379433,
          lng: 31.16558,
          size: 0.13,
          color: "white"
        },
        {
          name: "vietnam",
          lat: 14.058323999999999,
          lng: 108.277199,
          size: 0.14,
          color: "white"
        },
        {
          name: "finland",
          lat: 61.92411,
          lng: 25.748151,
          size: 0.12,
          color: "white"
        },
        {
          name: "south korea",
          lat: 35.907757000000004,
          lng: 127.766922,
          size: 0.1,
          color: "white"
        },
        {
          name: "denmark",
          lat: 56.26392,
          lng: 9.501785,
          size: 0.1,
          color: "white"
        },
        {
          name: "norway",
          lat: 60.472024,
          lng: 8.468946,
          size: 0.1,
          color: "white"
        },
        {
          name: "azerbaijan",
          lat: 40.143105,
          lng: 47.576927000000005,
          size: 0.1,
          color: "white"
        },
        {
          name: "peru",
          lat: -9.189967,
          lng: -75.015152,
          size: 0.12,
          color: "white"
        },
        {
          name: "pakistan",
          lat: 30.375321000000003,
          lng: 69.345116,
          size: 0.1,
          color: "white"
        },
        {
          name: "uzbekistan",
          lat: 41.377491,
          lng: 64.585262,
          size: 0.1,
          color: "white"
        },
        {
          name: "lebanon",
          lat: 33.854721000000005,
          lng: 35.862285,
          size: 0.1,
          color: "white"
        },
        {
          name: "estonia",
          lat: 58.595271999999994,
          lng: 25.013607,
          size: 0.11,
          color: "white"
        },
        {
          name: "kenya",
          lat: -0.023559,
          lng: 37.906193,
          size: 0.11,
          color: "white"
        },
        {
          name: "monaco",
          lat: 43.750298,
          lng: 7.412841,
          size: 0.1,
          color: "white"
        },
        {
          name: "romania",
          lat: 45.943160999999996,
          lng: 24.96676,
          size: 0.13,
          color: "white"
        },
        {
          name: "russia",
          lat: 61.52401,
          lng: 105.31875600000001,
          size: 0.11,
          color: "white"
        },
        {
          name: "slovenia",
          lat: 46.151241,
          lng: 14.995463,
          size: 0.1,
          color: "white"
        },
        {
          name: "czech republic",
          lat: 49.817492,
          lng: 15.472961999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "tanzania",
          lat: -6.369028,
          lng: 34.888822,
          size: 0.1,
          color: "white"
        },
        {
          name: "philippines",
          lat: 12.879721,
          lng: 121.77401699999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "nigeria",
          lat: 9.081999,
          lng: 8.675277000000001,
          size: 0.1,
          color: "white"
        },
        {
          name: "nepal",
          lat: 28.394857000000002,
          lng: 84.12400799999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "costa rica",
          lat: 9.748917,
          lng: -83.753428,
          size: 0.1,
          color: "white"
        },
        {
          name: "argentina",
          lat: -38.416097,
          lng: -63.616671999999994,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.45
        },
        {
          name: "malaysia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.210483999999999,
          endLng: 101.97576600000001,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.35
        },
        {
          name: "mexico",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.634501,
          endLng: -102.552784,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.22
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.35
        },
        {
          name: "brazil",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -14.235004,
          endLng: -51.92528,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.22
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "new zealand",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -40.900557,
          endLng: 174.88597099999998,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.2
        },
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "ethiopia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.145,
          endLng: 40.489672999999996,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "yemen",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 15.552726999999999,
          endLng: 48.516388,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "india",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 20.593684,
          endLng: 78.96288,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "colombia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.570868,
          endLng: -74.297333,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "australia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -25.274398,
          endLng: 133.775136,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "latvia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.879635,
          endLng: 24.603189,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.27
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "portugal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.399871999999995,
          endLng: -8.224454,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "iran",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 32.427908,
          endLng: 53.68804599999999,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "kuwait",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 29.311659999999996,
          endLng: 47.481766,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "indonesia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.789275,
          endLng: 113.921327,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "turkey",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 38.963745,
          endLng: 35.243322,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "ukraine",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.379433,
          endLng: 31.16558,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "vietnam",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 14.058323999999999,
          endLng: 108.277199,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "finland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.92411,
          endLng: 25.748151,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "south korea",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 35.907757000000004,
          endLng: 127.766922,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "denmark",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.26392,
          endLng: 9.501785,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "norway",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.472024,
          endLng: 8.468946,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "azerbaijan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.143105,
          endLng: 47.576927000000005,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "peru",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -9.189967,
          endLng: -75.015152,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "pakistan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 30.375321000000003,
          endLng: 69.345116,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "uzbekistan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.377491,
          endLng: 64.585262,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "lebanon",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.854721000000005,
          endLng: 35.862285,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "estonia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 58.595271999999994,
          endLng: 25.013607,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "kenya",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.023559,
          endLng: 37.906193,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "monaco",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 43.750298,
          endLng: 7.412841,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "romania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.943160999999996,
          endLng: 24.96676,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "russia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.52401,
          endLng: 105.31875600000001,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "slovenia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.151241,
          endLng: 14.995463,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "czech republic",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 49.817492,
          endLng: 15.472961999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "tanzania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -6.369028,
          endLng: 34.888822,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "philippines",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 12.879721,
          endLng: 121.77401699999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "nigeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.081999,
          endLng: 8.675277000000001,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "nepal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.394857000000002,
          endLng: 84.12400799999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "costa rica",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.748917,
          endLng: -83.753428,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "argentina",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -38.416097,
          endLng: -63.616671999999994,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    2021: {
      loc: [
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.48,
          color: "white"
        },
        {
          name: "brazil",
          lat: -14.235004,
          lng: -51.92528,
          size: 0.16,
          color: "white"
        },
        {
          name: "oman",
          lat: 21.512583,
          lng: 55.923255000000005,
          size: 0.1,
          color: "white"
        },
        {
          name: "south africa",
          lat: -30.559482,
          lng: 22.937506,
          size: 0.15,
          color: "white"
        },
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.16,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.26,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.23,
          color: "white"
        },
        {
          name: "kenya",
          lat: -0.023559,
          lng: 37.906193,
          size: 0.12,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.19,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.22,
          color: "white"
        },
        {
          name: "kuwait",
          lat: 29.311659999999996,
          lng: 47.481766,
          size: 0.18,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.11,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.11,
          color: "white"
        },
        {
          name: "portugal",
          lat: 39.399871999999995,
          lng: -8.224454,
          size: 0.13,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.11,
          color: "white"
        },
        {
          name: "new zealand",
          lat: -40.900557,
          lng: 174.88597099999998,
          size: 0.11,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.22,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.16,
          color: "white"
        },
        {
          name: "ethiopia",
          lat: 9.145,
          lng: 40.489672999999996,
          size: 0.11,
          color: "white"
        },
        {
          name: "colombia",
          lat: 4.570868,
          lng: -74.297333,
          size: 0.19,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.24,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.1,
          color: "white"
        },
        {
          name: "ecuador",
          lat: -1.8312389999999998,
          lng: -78.183406,
          size: 0.11,
          color: "white"
        },
        {
          name: "chile",
          lat: -35.675146999999996,
          lng: -71.542969,
          size: 0.1,
          color: "white"
        },
        {
          name: "tanzania",
          lat: -6.369028,
          lng: 34.888822,
          size: 0.1,
          color: "white"
        },
        {
          name: "uganda",
          lat: 1.373333,
          lng: 32.290275,
          size: 0.1,
          color: "white"
        },
        {
          name: "malaysia",
          lat: 4.210483999999999,
          lng: 101.97576600000001,
          size: 0.12,
          color: "white"
        },
        {
          name: "pakistan",
          lat: 30.375321000000003,
          lng: 69.345116,
          size: 0.12,
          color: "white"
        },
        {
          name: "turkey",
          lat: 38.963745,
          lng: 35.243322,
          size: 0.13,
          color: "white"
        },
        {
          name: "czech republic",
          lat: 49.817492,
          lng: 15.472961999999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.17,
          color: "white"
        },
        {
          name: "romania",
          lat: 45.943160999999996,
          lng: 24.96676,
          size: 0.16,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.17,
          color: "white"
        },
        {
          name: "albania",
          lat: 41.153332,
          lng: 20.168331,
          size: 0.1,
          color: "white"
        },
        {
          name: "australia",
          lat: -25.274398,
          lng: 133.775136,
          size: 0.13,
          color: "white"
        },
        {
          name: "mexico",
          lat: 23.634501,
          lng: -102.552784,
          size: 0.16,
          color: "white"
        },
        {
          name: "nigeria",
          lat: 9.081999,
          lng: 8.675277000000001,
          size: 0.1,
          color: "white"
        },
        {
          name: "norway",
          lat: 60.472024,
          lng: 8.468946,
          size: 0.12,
          color: "white"
        },
        {
          name: "denmark",
          lat: 56.26392,
          lng: 9.501785,
          size: 0.13,
          color: "white"
        },
        {
          name: "vietnam",
          lat: 14.058323999999999,
          lng: 108.277199,
          size: 0.12,
          color: "white"
        },
        {
          name: "peru",
          lat: -9.189967,
          lng: -75.015152,
          size: 0.1,
          color: "white"
        },
        {
          name: "finland",
          lat: 61.92411,
          lng: 25.748151,
          size: 0.11,
          color: "white"
        },
        {
          name: "philippines",
          lat: 12.879721,
          lng: 121.77401699999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "indonesia",
          lat: -0.789275,
          lng: 113.921327,
          size: 0.1,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.11,
          color: "white"
        },
        {
          name: "iran",
          lat: 32.427908,
          lng: 53.68804599999999,
          size: 0.11,
          color: "white"
        },
        {
          name: "ukraine",
          lat: 48.379433,
          lng: 31.16558,
          size: 0.11,
          color: "white"
        },
        {
          name: "argentina",
          lat: -38.416097,
          lng: -63.616671999999994,
          size: 0.11,
          color: "white"
        },
        {
          name: "lebanon",
          lat: 33.854721000000005,
          lng: 35.862285,
          size: 0.1,
          color: "white"
        },
        {
          name: "slovenia",
          lat: 46.151241,
          lng: 14.995463,
          size: 0.1,
          color: "white"
        },
        {
          name: "south korea",
          lat: 35.907757000000004,
          lng: 127.766922,
          size: 0.1,
          color: "white"
        },
        {
          name: "iraq",
          lat: 33.223191,
          lng: 43.679291,
          size: 0.1,
          color: "white"
        },
        {
          name: "rwanda",
          lat: -1.940278,
          lng: 29.873888,
          size: 0.1,
          color: "white"
        },
        {
          name: "russia",
          lat: 61.52401,
          lng: 105.31875600000001,
          size: 0.13,
          color: "white"
        },
        {
          name: "estonia",
          lat: 58.595271999999994,
          lng: 25.013607,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.48
        },
        {
          name: "brazil",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -14.235004,
          endLng: -51.92528,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "oman",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 21.512583,
          endLng: 55.923255000000005,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "south africa",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -30.559482,
          endLng: 22.937506,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "india",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 20.593684,
          endLng: 78.96288,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.26
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.23
        },
        {
          name: "kenya",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.023559,
          endLng: 37.906193,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.19
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.22
        },
        {
          name: "kuwait",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 29.311659999999996,
          endLng: 47.481766,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "portugal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.399871999999995,
          endLng: -8.224454,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "new zealand",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -40.900557,
          endLng: 174.88597099999998,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.22
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "ethiopia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.145,
          endLng: 40.489672999999996,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "colombia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.570868,
          endLng: -74.297333,
          color: ["blue", "red"],
          stroke: 0.19
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "ecuador",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -1.8312389999999998,
          endLng: -78.183406,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "chile",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -35.675146999999996,
          endLng: -71.542969,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "tanzania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -6.369028,
          endLng: 34.888822,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "uganda",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 1.373333,
          endLng: 32.290275,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "malaysia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.210483999999999,
          endLng: 101.97576600000001,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "pakistan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 30.375321000000003,
          endLng: 69.345116,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "turkey",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 38.963745,
          endLng: 35.243322,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "czech republic",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 49.817492,
          endLng: 15.472961999999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "romania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.943160999999996,
          endLng: 24.96676,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.17
        },
        {
          name: "albania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.153332,
          endLng: 20.168331,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "australia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -25.274398,
          endLng: 133.775136,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "mexico",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.634501,
          endLng: -102.552784,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "nigeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.081999,
          endLng: 8.675277000000001,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "norway",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.472024,
          endLng: 8.468946,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "denmark",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.26392,
          endLng: 9.501785,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "vietnam",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 14.058323999999999,
          endLng: 108.277199,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "peru",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -9.189967,
          endLng: -75.015152,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "finland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.92411,
          endLng: 25.748151,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "philippines",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 12.879721,
          endLng: 121.77401699999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "indonesia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.789275,
          endLng: 113.921327,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "iran",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 32.427908,
          endLng: 53.68804599999999,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "ukraine",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.379433,
          endLng: 31.16558,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "argentina",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -38.416097,
          endLng: -63.616671999999994,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "lebanon",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.854721000000005,
          endLng: 35.862285,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "slovenia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.151241,
          endLng: 14.995463,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "south korea",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 35.907757000000004,
          endLng: 127.766922,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "iraq",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.223191,
          endLng: 43.679291,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "rwanda",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -1.940278,
          endLng: 29.873888,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "russia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.52401,
          endLng: 105.31875600000001,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "estonia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 58.595271999999994,
          endLng: 25.013607,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    },
    "all years": {
      loc: [
        {
          name: "france",
          lat: 46.227638,
          lng: 2.213749,
          size: 1.1,
          color: "white"
        },
        {
          name: "canada",
          lat: 56.130366,
          lng: -106.34677099999999,
          size: 0.39,
          color: "white"
        },
        {
          name: "spain",
          lat: 40.463667,
          lng: -3.7492199999999998,
          size: 0.28,
          color: "white"
        },
        {
          name: "malaysia",
          lat: 4.210483999999999,
          lng: 101.97576600000001,
          size: 0.13,
          color: "white"
        },
        {
          name: "germany",
          lat: 51.165690999999995,
          lng: 10.451526,
          size: 0.32,
          color: "white"
        },
        {
          name: "mexico",
          lat: 23.634501,
          lng: -102.552784,
          size: 0.15,
          color: "white"
        },
        {
          name: "saudi arabia",
          lat: 23.885942,
          lng: 45.079162,
          size: 0.19,
          color: "white"
        },
        {
          name: "belgium",
          lat: 50.503887,
          lng: 4.469936,
          size: 0.16,
          color: "white"
        },
        {
          name: "sweden",
          lat: 60.128161,
          lng: 18.643501,
          size: 0.23,
          color: "white"
        },
        {
          name: "brazil",
          lat: -14.235004,
          lng: -51.92528,
          size: 0.16,
          color: "white"
        },
        {
          name: "switzerland",
          lat: 46.818188,
          lng: 8.227511999999999,
          size: 0.16,
          color: "white"
        },
        {
          name: "new zealand",
          lat: -40.900557,
          lng: 174.88597099999998,
          size: 0.12,
          color: "white"
        },
        {
          name: "poland",
          lat: 51.919438,
          lng: 19.145135999999997,
          size: 0.18,
          color: "white"
        },
        {
          name: "egypt",
          lat: 26.820553000000004,
          lng: 30.802497999999996,
          size: 0.24,
          color: "white"
        },
        {
          name: "ethiopia",
          lat: 9.145,
          lng: 40.489672999999996,
          size: 0.13,
          color: "white"
        },
        {
          name: "tunisia",
          lat: 33.886917,
          lng: 9.537499,
          size: 0.22,
          color: "white"
        },
        {
          name: "oman",
          lat: 21.512583,
          lng: 55.923255000000005,
          size: 0.1,
          color: "white"
        },
        {
          name: "south africa",
          lat: -30.559482,
          lng: 22.937506,
          size: 0.11,
          color: "white"
        },
        {
          name: "india",
          lat: 20.593684,
          lng: 78.96288,
          size: 0.16,
          color: "white"
        },
        {
          name: "yemen",
          lat: 15.552726999999999,
          lng: 48.516388,
          size: 0.1,
          color: "white"
        },
        {
          name: "kenya",
          lat: -0.023559,
          lng: 37.906193,
          size: 0.12,
          color: "white"
        },
        {
          name: "algeria",
          lat: 28.033886,
          lng: 1.6596259999999998,
          size: 0.12,
          color: "white"
        },
        {
          name: "colombia",
          lat: 4.570868,
          lng: -74.297333,
          size: 0.15,
          color: "white"
        },
        {
          name: "israel",
          lat: 31.046051000000002,
          lng: 34.851612,
          size: 0.1,
          color: "white"
        },
        {
          name: "kuwait",
          lat: 29.311659999999996,
          lng: 47.481766,
          size: 0.15,
          color: "white"
        },
        {
          name: "japan",
          lat: 36.204824,
          lng: 138.252924,
          size: 0.14,
          color: "white"
        },
        {
          name: "italy",
          lat: 41.87194,
          lng: 12.56738,
          size: 0.16,
          color: "white"
        },
        {
          name: "greece",
          lat: 39.074208,
          lng: 21.824312,
          size: 0.13,
          color: "white"
        },
        {
          name: "australia",
          lat: -25.274398,
          lng: 133.775136,
          size: 0.14,
          color: "white"
        },
        {
          name: "latvia",
          lat: 56.879635,
          lng: 24.603189,
          size: 0.11,
          color: "white"
        },
        {
          name: "singapore",
          lat: 1.352083,
          lng: 103.819836,
          size: 0.1,
          color: "white"
        },
        {
          name: "portugal",
          lat: 39.399871999999995,
          lng: -8.224454,
          size: 0.13,
          color: "white"
        },
        {
          name: "hungary",
          lat: 47.162494,
          lng: 19.503304,
          size: 0.12,
          color: "white"
        },
        {
          name: "iran",
          lat: 32.427908,
          lng: 53.68804599999999,
          size: 0.12,
          color: "white"
        },
        { name: "croatia", lat: 45.1, lng: 15.2, size: 0.1, color: "white" },
        {
          name: "nepal",
          lat: 28.394857000000002,
          lng: 84.12400799999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "indonesia",
          lat: -0.789275,
          lng: 113.921327,
          size: 0.11,
          color: "white"
        },
        {
          name: "ecuador",
          lat: -1.8312389999999998,
          lng: -78.183406,
          size: 0.1,
          color: "white"
        },
        {
          name: "chile",
          lat: -35.675146999999996,
          lng: -71.542969,
          size: 0.1,
          color: "white"
        },
        {
          name: "tanzania",
          lat: -6.369028,
          lng: 34.888822,
          size: 0.1,
          color: "white"
        },
        {
          name: "uganda",
          lat: 1.373333,
          lng: 32.290275,
          size: 0.1,
          color: "white"
        },
        {
          name: "pakistan",
          lat: 30.375321000000003,
          lng: 69.345116,
          size: 0.11,
          color: "white"
        },
        {
          name: "turkey",
          lat: 38.963745,
          lng: 35.243322,
          size: 0.12,
          color: "white"
        },
        {
          name: "bulgaria",
          lat: 42.733883,
          lng: 25.48583,
          size: 0.1,
          color: "white"
        },
        {
          name: "czech republic",
          lat: 49.817492,
          lng: 15.472961999999999,
          size: 0.11,
          color: "white"
        },
        {
          name: "romania",
          lat: 45.943160999999996,
          lng: 24.96676,
          size: 0.13,
          color: "white"
        },
        {
          name: "ukraine",
          lat: 48.379433,
          lng: 31.16558,
          size: 0.12,
          color: "white"
        },
        {
          name: "albania",
          lat: 41.153332,
          lng: 20.168331,
          size: 0.1,
          color: "white"
        },
        {
          name: "lebanon",
          lat: 33.854721000000005,
          lng: 35.862285,
          size: 0.11,
          color: "white"
        },
        {
          name: "nigeria",
          lat: 9.081999,
          lng: 8.675277000000001,
          size: 0.11,
          color: "white"
        },
        {
          name: "vietnam",
          lat: 14.058323999999999,
          lng: 108.277199,
          size: 0.13,
          color: "white"
        },
        {
          name: "finland",
          lat: 61.92411,
          lng: 25.748151,
          size: 0.12,
          color: "white"
        },
        {
          name: "norway",
          lat: 60.472024,
          lng: 8.468946,
          size: 0.11,
          color: "white"
        },
        {
          name: "denmark",
          lat: 56.26392,
          lng: 9.501785,
          size: 0.11,
          color: "white"
        },
        {
          name: "south korea",
          lat: 35.907757000000004,
          lng: 127.766922,
          size: 0.11,
          color: "white"
        },
        {
          name: "peru",
          lat: -9.189967,
          lng: -75.015152,
          size: 0.11,
          color: "white"
        },
        {
          name: "philippines",
          lat: 12.879721,
          lng: 121.77401699999999,
          size: 0.1,
          color: "white"
        },
        {
          name: "azerbaijan",
          lat: 40.143105,
          lng: 47.576927000000005,
          size: 0.1,
          color: "white"
        },
        {
          name: "uzbekistan",
          lat: 41.377491,
          lng: 64.585262,
          size: 0.1,
          color: "white"
        },
        {
          name: "ghana",
          lat: 7.946527000000001,
          lng: -1.0231940000000002,
          size: 0.1,
          color: "white"
        },
        {
          name: "estonia",
          lat: 58.595271999999994,
          lng: 25.013607,
          size: 0.11,
          color: "white"
        },
        {
          name: "kazakhstan",
          lat: 48.019573,
          lng: 66.923684,
          size: 0.1,
          color: "white"
        },
        {
          name: "argentina",
          lat: -38.416097,
          lng: -63.616671999999994,
          size: 0.11,
          color: "white"
        },
        {
          name: "monaco",
          lat: 43.750298,
          lng: 7.412841,
          size: 0.11,
          color: "white"
        },
        {
          name: "slovenia",
          lat: 46.151241,
          lng: 14.995463,
          size: 0.11,
          color: "white"
        },
        {
          name: "russia",
          lat: 61.52401,
          lng: 105.31875600000001,
          size: 0.12,
          color: "white"
        },
        {
          name: "sudan",
          lat: 12.862807,
          lng: 30.217636,
          size: 0.1,
          color: "white"
        },
        {
          name: "iraq",
          lat: 33.223191,
          lng: 43.679291,
          size: 0.1,
          color: "white"
        },
        {
          name: "rwanda",
          lat: -1.940278,
          lng: 29.873888,
          size: 0.1,
          color: "white"
        },
        {
          name: "qatar",
          lat: 25.354826,
          lng: 51.183884,
          size: 0.1,
          color: "white"
        },
        {
          name: "costa rica",
          lat: 9.748917,
          lng: -83.753428,
          size: 0.1,
          color: "white"
        }
      ],
      arcs: [
        {
          name: "france",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.227638,
          endLng: 2.213749,
          color: ["blue", "red"],
          stroke: 1.1
        },
        {
          name: "canada",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.130366,
          endLng: -106.34677099999999,
          color: ["blue", "red"],
          stroke: 0.39
        },
        {
          name: "spain",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.463667,
          endLng: -3.7492199999999998,
          color: ["blue", "red"],
          stroke: 0.28
        },
        {
          name: "malaysia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.210483999999999,
          endLng: 101.97576600000001,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "germany",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.165690999999995,
          endLng: 10.451526,
          color: ["blue", "red"],
          stroke: 0.32
        },
        {
          name: "mexico",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.634501,
          endLng: -102.552784,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "saudi arabia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 23.885942,
          endLng: 45.079162,
          color: ["blue", "red"],
          stroke: 0.19
        },
        {
          name: "belgium",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 50.503887,
          endLng: 4.469936,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "sweden",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.128161,
          endLng: 18.643501,
          color: ["blue", "red"],
          stroke: 0.23
        },
        {
          name: "brazil",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -14.235004,
          endLng: -51.92528,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "switzerland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.818188,
          endLng: 8.227511999999999,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "new zealand",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -40.900557,
          endLng: 174.88597099999998,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "poland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 51.919438,
          endLng: 19.145135999999997,
          color: ["blue", "red"],
          stroke: 0.18
        },
        {
          name: "egypt",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 26.820553000000004,
          endLng: 30.802497999999996,
          color: ["blue", "red"],
          stroke: 0.24
        },
        {
          name: "ethiopia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.145,
          endLng: 40.489672999999996,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "tunisia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.886917,
          endLng: 9.537499,
          color: ["blue", "red"],
          stroke: 0.22
        },
        {
          name: "oman",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 21.512583,
          endLng: 55.923255000000005,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "south africa",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -30.559482,
          endLng: 22.937506,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "india",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 20.593684,
          endLng: 78.96288,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "yemen",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 15.552726999999999,
          endLng: 48.516388,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "kenya",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.023559,
          endLng: 37.906193,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "algeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.033886,
          endLng: 1.6596259999999998,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "colombia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 4.570868,
          endLng: -74.297333,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "israel",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 31.046051000000002,
          endLng: 34.851612,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "kuwait",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 29.311659999999996,
          endLng: 47.481766,
          color: ["blue", "red"],
          stroke: 0.15
        },
        {
          name: "japan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 36.204824,
          endLng: 138.252924,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "italy",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.87194,
          endLng: 12.56738,
          color: ["blue", "red"],
          stroke: 0.16
        },
        {
          name: "greece",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.074208,
          endLng: 21.824312,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "australia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -25.274398,
          endLng: 133.775136,
          color: ["blue", "red"],
          stroke: 0.14
        },
        {
          name: "latvia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.879635,
          endLng: 24.603189,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "singapore",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 1.352083,
          endLng: 103.819836,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "portugal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 39.399871999999995,
          endLng: -8.224454,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "hungary",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 47.162494,
          endLng: 19.503304,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "iran",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 32.427908,
          endLng: 53.68804599999999,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "croatia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.1,
          endLng: 15.2,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "nepal",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 28.394857000000002,
          endLng: 84.12400799999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "indonesia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -0.789275,
          endLng: 113.921327,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "ecuador",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -1.8312389999999998,
          endLng: -78.183406,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "chile",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -35.675146999999996,
          endLng: -71.542969,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "tanzania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -6.369028,
          endLng: 34.888822,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "uganda",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 1.373333,
          endLng: 32.290275,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "pakistan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 30.375321000000003,
          endLng: 69.345116,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "turkey",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 38.963745,
          endLng: 35.243322,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "bulgaria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 42.733883,
          endLng: 25.48583,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "czech republic",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 49.817492,
          endLng: 15.472961999999999,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "romania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 45.943160999999996,
          endLng: 24.96676,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "ukraine",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.379433,
          endLng: 31.16558,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "albania",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.153332,
          endLng: 20.168331,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "lebanon",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.854721000000005,
          endLng: 35.862285,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "nigeria",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.081999,
          endLng: 8.675277000000001,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "vietnam",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 14.058323999999999,
          endLng: 108.277199,
          color: ["blue", "red"],
          stroke: 0.13
        },
        {
          name: "finland",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.92411,
          endLng: 25.748151,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "norway",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 60.472024,
          endLng: 8.468946,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "denmark",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 56.26392,
          endLng: 9.501785,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "south korea",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 35.907757000000004,
          endLng: 127.766922,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "peru",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -9.189967,
          endLng: -75.015152,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "philippines",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 12.879721,
          endLng: 121.77401699999999,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "azerbaijan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 40.143105,
          endLng: 47.576927000000005,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "uzbekistan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 41.377491,
          endLng: 64.585262,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "ghana",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 7.946527000000001,
          endLng: -1.0231940000000002,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "estonia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 58.595271999999994,
          endLng: 25.013607,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "kazakhstan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 48.019573,
          endLng: 66.923684,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "argentina",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -38.416097,
          endLng: -63.616671999999994,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "monaco",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 43.750298,
          endLng: 7.412841,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "slovenia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 46.151241,
          endLng: 14.995463,
          color: ["blue", "red"],
          stroke: 0.11
        },
        {
          name: "russia",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 61.52401,
          endLng: 105.31875600000001,
          color: ["blue", "red"],
          stroke: 0.12
        },
        {
          name: "sudan",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 12.862807,
          endLng: 30.217636,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "iraq",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 33.223191,
          endLng: 43.679291,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "rwanda",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: -1.940278,
          endLng: 29.873888,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "qatar",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 25.354826,
          endLng: 51.183884,
          color: ["blue", "red"],
          stroke: 0.1
        },
        {
          name: "costa rica",
          startLat: 31.791702,
          startLng: -7.09262,
          endLat: 9.748917,
          endLng: -83.753428,
          color: ["blue", "red"],
          stroke: 0.1
        }
      ]
    }
  };
  export default data;
  